import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AdminDashboardStatsResponse } from "reduxStore/dataTypes";

interface AdminDashboardStatsState {
  adminDashboardStats: AdminDashboardStatsResponse | null;
  loading: boolean;
  error: string | null;
}

const initialState: AdminDashboardStatsState = {
  adminDashboardStats: null,
  loading: false,
  error: null,
};

const adminDashboardStatsSlice = createSlice({
  name: "adminDashboardStats",
  initialState,
  reducers: {
    adminDashboardStatsRequest(state) {
      state.loading = true;
      state.error = null;
    },
    adminDashboardStatsSuccess(
      state,
      action: PayloadAction<AdminDashboardStatsResponse>
    ) {
      state.loading = false;
      state.adminDashboardStats = action.payload;
    },
    adminDashboardStatsFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  adminDashboardStatsRequest,
  adminDashboardStatsSuccess,
  adminDashboardStatsFailure,
} = adminDashboardStatsSlice.actions;
export default adminDashboardStatsSlice.reducer;
